import React from 'react';
import Portfolio from '../../components/portfolio/Portfolio.js';

const NerdArea = () => {
  return (
    <div>
      <Portfolio />
    </div>
  )
}

export default NerdArea;